import { render, staticRenderFns } from "./prospeccoesSidebar.vue?vue&type=template&id=9dc853dc"
import script from "./prospeccoesSidebar.vue?vue&type=script&lang=js"
export * from "./prospeccoesSidebar.vue?vue&type=script&lang=js"
import style0 from "./prospeccoesSidebar.vue?vue&type=style&index=0&id=9dc853dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports